// import { faSuitcase } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "components/Button";
import React from "react";
import Carousel from "components/Carousel";
import { FormattedMessage } from "gatsby-plugin-intl";
import PageSection from "components/PageSection";
import { CAROUSEL_IMAGES } from "./images";

const Partners = () => {
  return (
    <PageSection id="partners" startIconTo="partners" pattern={null}>
      <div className="container">
        <div className="container flex flex-col">
          <h3 className="text-black text-p-title font-semibold mb-8 text-center">
            <FormattedMessage id="paragraph.partner.header" />
          </h3>
          <Carousel images={CAROUSEL_IMAGES} />
        </div>
      </div>
    </PageSection>
  );
};

export default Partners;
